import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ErrorBoundary } from 'components/ErrorBoundary/ErrorBoundary';
import { ProductsLoader } from 'components/ProductsLoader/ProductsLoader';
import { IntroducerDataProvider } from 'contexts/IntroducerData/IntroducerData.context';

import '../index.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'normalize.css';
import 'driver.js/dist/driver.css';
import '../styles/driver-overrides.css';
import '../styles/shared.css';

import '@iwoca/orion/css/colors.css';
import '@iwoca/orion/css/radii.css';
import '@iwoca/orion/css/shadows.css';
import '@iwoca/orion/css/text.css';
import '@iwoca/orion/css/spacers.css';
import '@iwoca/orion/lib/css/orion.css';
import '@iwoca/orion/css/fonts.css';

import { ForbiddenPage } from 'pages/403';
import { NotFoundPage } from 'pages/404';
import { AccountOverviewPage } from 'pages/account-overview';
import { ApplicationOverviewPage } from 'pages/application';
import { DocumentsPage } from 'pages/application/documents';
import { NewApplicationPage } from 'pages/application/new';
import { CheckDetailsPage } from 'pages/application/new/check-details';
import { ProductOffersPage } from 'pages/application/new/product-offers';
import { TradingHistoryPage } from 'pages/application/new/trading-history';
import { CalculatorPage } from 'pages/calculator';
import { FAQsPage } from 'pages/faqs';
import { HomePage } from 'pages/home';
import { PortalToursPage } from 'pages/portal-tours';
import { ProductsPage } from 'pages/products';
import { RegisterPage } from 'pages/register';
import { RegistrationDocumentsPage } from 'pages/registration-documents';
import { WhatsNewPage } from 'pages/whats-new';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { IwQueryClientProvider } from 'store/IwQueryClientProvider';
import {
  getBasename,
  initializeDataDog,
  initializeLingui,
  initialiseTracking,
} from './App.helpers';

initializeDataDog();
initializeLingui();
initialiseTracking();

export const App = () => {
  return (
    <I18nProvider i18n={i18n as any}>
      <IwQueryClientProvider>
        <Router basename={getBasename()}>
          <ErrorBoundary locale={i18n.locale}>
            <IntroducerDataProvider>
              <ProductsLoader>
                <Routes>
                  <Route path="/" Component={HomePage} />
                  <Route path="/products" Component={ProductsPage} />
                  <Route path="/register/*" Component={RegisterPage} />
                  <Route path="/faqs" Component={FAQsPage} />
                  <Route path="/calculator" Component={CalculatorPage} />
                  <Route path="/403" Component={ForbiddenPage} />
                  <Route path="/whats-new" Component={WhatsNewPage} />
                  <Route
                    path="/registration-documents"
                    Component={RegistrationDocumentsPage}
                  />
                  <Route path="/portal-tours" Component={PortalToursPage} />
                  <Route
                    path="/account-overview"
                    Component={AccountOverviewPage}
                  />
                  <Route
                    path="/application/new/product-offers"
                    Component={ProductOffersPage}
                  />
                  <Route
                    path="/application/new/documents"
                    Component={TradingHistoryPage}
                  />
                  <Route
                    path="/application/new/check-details"
                    Component={CheckDetailsPage}
                  />
                  <Route
                    path="/application/new"
                    Component={NewApplicationPage}
                  />
                  <Route
                    path="/application/documents"
                    Component={DocumentsPage}
                  />
                  <Route
                    path="/application"
                    Component={ApplicationOverviewPage}
                  />
                  <Route path="*" Component={NotFoundPage} />
                </Routes>
              </ProductsLoader>
            </IntroducerDataProvider>
          </ErrorBoundary>
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
      </IwQueryClientProvider>
    </I18nProvider>
  );
};
